import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { countries } from '@root/common/countries';
import { HttpClient } from '@angular/common/http';
import format from 'date-fns/format';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import _ from 'lodash';
import { TranslateService } from '@root/shared/service/translate.service';
import { InternationalService } from '@root/international.service';
import { AppService } from '@root/app.service';
@Component({
  selector: 'host-edit-guest',
  templateUrl: './edit-guest.component.html',
  styleUrls: ['./edit-guest.component.scss']
})
export class EditGuestComponent implements OnInit {
  private readonly editClientApi = '/api/client/client_save';
  private readonly countryListApi = '/api/client/areas';
  // private readonly tagListApi = '/api/house_status_setting/get';
  @Input() type: 'create' | 'update' = 'create';
  @Input() guestInfo = null; // type = 'create' 时传递过来的填充数据
  // @Output() onSuccess = new EventEmitter();
  _idTypeOptions = [
    { label: '身份证', value: 'id_card', key: 'guest.list.id_card' },
    { label: '护照', value: 'passport', key: 'guest.list.passport' },
    { label: '港澳台通行证', value: 'gang_ao_tai_card', key: 'guest.list.exit_entry_permit' },
    { label: '军人证', value: 'serviceman_card', key: 'guest.list.military_id' },
  ];
  countryOptions = [];
  tagOptions = [];
  form: FormGroup = this.fb.group({
    id: null,
    name: '',
    gender: 1,
    phone: '',
    email: '',
    id_type: [null],
    id_number: '',
    birthday: [null],
    country: '',
    comment: '',
    client_tags: [[]],
    client_credential: [[]],
  })

  get isInternational () {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  get idTypeOptions() {
    return this.isInternational ? this._idTypeOptions.slice(0, 2) : this._idTypeOptions;
  }
  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private modalService: NzModalService,
    private translate: TranslateService,
    // private international: InternationalService,
    private app: AppService
  ) { }

  ngOnInit() {
    this.requestCountryList();
    // this.requestTagList();
    if (this.guestInfo) {
      // this.guestInfo.comment = this.guestInfo.comment || _.get(this.guestInfo, 'client_comment.comment')
      this.form.patchValue(this.guestInfo);
    }
  }

  requestCountryList () {
    this.http.get(this.countryListApi).subscribe(res => {
      const areas = _.get(res, 'data') || [];
      this.countryOptions = _.flatten(_.map(areas, 'members'));
    });
  }

  requestEditGuest () {
    const value = this.form.value;

    const params = { ...value };

    const tagIds = value.client_tags.map(tag => tag.id);

    params.client_credential = JSON.stringify(value.client_credential);
    params.birthday = value.birthday ? format(value.birthday, 'YYYY-MM-DD') : null;
    params.tag_ids = JSON.stringify(tagIds);

    delete params['client_tags']

    this.http.post(this.editClientApi, params).subscribe((res: any) => {

      if (res.error_code === 0) {
        const id = _.get(res, 'data.id');
        const hasSimilar = _.get(res, 'data.has_similar');
        if (hasSimilar/* @TODO 接口缺少字段 */) {
          this.modalService.warning({
            nzTitle: this.translate.syncGet('modal.add_guest.warning_title'),
            nzOkText: this.translate.syncGet('modal.add_guest.warning_btn')
          });
        }

        this.modalRef.destroy({
          type: 'onSuccess',
          data: { id }
        })

      }
    });
  }

  // requestTagList () {
  //   this.http.get(this.tagListApi).subscribe(res => {
  //     console.log('taglist: ', res);
  //     this.tagOptions = _.get(res, 'data.client_tag_list') || [];
  //   });
  // }

  onClickConfirm () {
    this.requestEditGuest();
  }

  onClickCancel () {
    this.modalRef.destroy();
  }

}
